import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useExposiciones } from '../../../hooks/useExposiciones.js'
import ExposicionTipo from './ExposicionTipo'
import './ExposicionTipo.css'

const Exposicion = ({
  onChange,
  precioUnitario,
  idCategoria,
  esScrap,
  checked,
  alicuota,
  onAvisoChange,
  onFechaPrevistaChange,
  esPresupuesto
}) => {
  const { exposiciones, aviso, fechaVencimientoPrevista } = useExposiciones({
    idCategoria,
    esScrap,
    precioUnitario,
    alicuota,
    idSeleccionada: checked
  })

  useEffect(() => {
    onAvisoChange?.(aviso)
  }, [aviso, onAvisoChange])

  useEffect(() => {
    onFechaPrevistaChange?.(fechaVencimientoPrevista)
  }, [fechaVencimientoPrevista, onFechaPrevistaChange])

  const handleOptionChange = function (e) {
    onChange(e, 'num')
  }

  return (
    <div className="exposicionTipo-contenedor">
      {exposiciones.map((exposicion) => (
        <ExposicionTipo
          key={exposicion.idPublicacionExposicion}
          name="idPublicacionExposicion"
          value={exposicion.idPublicacionExposicion}
          checked={checked === exposicion.idPublicacionExposicion}
          onChange={handleOptionChange}
          exposicion={exposicion}
          esPresupuesto={esPresupuesto}
        />
      ))}
    </div>
  )
}

Exposicion.propTypes = {
  onChange: PropTypes.func.isRequired,
  precioUnitario: PropTypes.number,
  idCategoria: PropTypes.number,
  esScrap: PropTypes.bool,
  checked: PropTypes.number,
  alicuota: PropTypes.number,
  onAvisoChange: PropTypes.func,
  onFechaPrevistaChange: PropTypes.func,
  esPresupuesto: PropTypes.bool
}

export default Exposicion
